/**
 * Dev Notes: This file manage the drawer cart and also this manage the /cart page.
 * It uses Cart.JS API to make the updates in the cart page and drawer cart.
 */
;(function (InlineCart, $) {
  'use strict';

  let $dom = {};
  const freeSampleProductIDs = [
    1298199380042, // summer body starter kit
    4347490205770, // summer body kit (female)
    4347450228810, // summer body kit (male)
  ]

  const cacheDom = () => {
    $dom.inlineCart = $('[data-inline-cart]');
    $dom.lineItemEntryPoint = $('[data-cart-contents]');
    $dom.totalItemCount = $('.js-bag-count');
    $dom.toggleCart = $('[data-show-cart]');
    $dom.closeCart = $('[data-close-cart]');
    $dom.removeLineItem = $('[data-remove-item]');

    $dom.body = $('body');
    $dom.pdpFreeSamplesModalToggleSelector = '[data-pdp-free-samples-modal-toggle]';
    $dom.pdpFreeSamplesModalSelector = '[data-pdp-free-samples-modal]';
    $dom.pdpFreeSamplesModal = $(`${$dom.pdpFreeSamplesModalSelector}`);
    $dom.pdpFreeSamplesModalCloseBtn = $('[data-close-pdp-free-samples-modal]');
    $dom.pdpFreeSamplesModalItemsList = $('[data-pdp-free-samples-modal-items-list]');
    $dom.pdpFreeSamplesModalSaveButton = $('[data-pdp-free-samples-modal-save]');
    $dom.pdpFreeSamplesModalVariantAttribute = 'data-modal-pdp-free-sample-variant';
    $dom.pdpFreeSamplesModalVariantSelector = `[${$dom.pdpFreeSamplesModalVariantAttribute}]`;
    $dom.pdpFreeSamplesModalVariantSelectboxSelector = '[data-modal-pdp-free-sample-select]';
    $dom.pdpFreeSamplesModalNewVariantAttribute = 'data-modal-pdp-free-sample-new-variant';
  };

  InlineCart.update = (callback) => {
    $.get('/cart?view=contents')
    .then(response => {
      $dom.lineItemEntryPoint.html(response);
      InlineCart.itemCountTotal();

      InlineCart.PDPFreeSamplesModal.update();
      InlineCart.updateRewardsPoints();

      if (typeof callback === 'function') {
        callback();
      }
    })
    .done(() => {
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
      $('.js-style-select').selectric();

      // update cart widget after cart updates
      if (window.cartDiscount.enabled_in_cart) {
        updateDiscountWidget('cart', window.cartDiscount.threshold);
      }

      InlineCart.discountProgressBar();
    });

    if (callback === 'upsell') {
    }
  };

  InlineCart.toggle = action => {
    if (action === 'show') {
      Overlay.show();
      $dom.inlineCart.addClass('is-active');
      InlineCart.updateRewardsPoints();
      
    } else if (action === 'hide') {
      Overlay.hide();
      $dom.inlineCart.removeClass('is-active');
    }
  }

  InlineCart.updateRewardsPoints = () => {
    $dom.rewardPointsHeader = $('.nav-header__points-balance .yotpo-description');
    //get injected rewards points balance on function run
    $dom.rewardsPointsCart = $('.inline-cart-points');
    const rewardsPointsValue = $dom.rewardPointsHeader.text();

    if ($dom.rewardsPointsCart) {
      //if rewards element appears in inline cart, update the value
      $dom.rewardsPointsCart.text(rewardsPointsValue);
    }
  }

  InlineCart.addItem = (id, quantity, property={}) => {
    CartJS.addItem(id, quantity, property, {
      success: (data, textStatus, jqXHR) => {
      
      },

      error: (jqXHR, textStatus, errorThrown) => {
        window.alert('Sorry, we\'re unable to do that.\n' + JSON.parse(jqXHR.responseText).description);
      }
    });
  };

  InlineCart.removeItem = (id) => {
    CartJS.updateItemById(id, 0, null, {
      success: (data, textStatus, jqXHR) => {
      },

      error: (jqXHR, textStatus, errorThrown) => {
        window.alert('Sorry, we\'re unable to do that.\n');
      }
    });
  };

  InlineCart.itemCountTotal = () => {
    let itemCount = 0;

    if (CartJS.cart.item_count > 99) {
      itemCount = '99+';
    } else {
      itemCount = CartJS.cart.item_count;
    }

    if (parseInt(itemCount) > 0) {
      $dom.totalItemCount.addClass('is-active');
    } else {
      $dom.totalItemCount.removeClass('is-active');
    }

    $dom.totalItemCount.text(itemCount);
  };

  InlineCart.removeDuplicateGWPs = () => {
    let gwpLineItems = CartJS.cart.items.filter(i => i.properties._is_gwp !== undefined);
    let duplicateGWPs = gwpLineItems.filter(i => i.quantity > 1);

    if (duplicateGWPs.length) {
      let updates = {};

      duplicateGWPs.forEach(item => {
        updates[item.key+''] = 1;
      });

      let $checkoutButton = $('.inline-cart button[type="submit"]:visible');
      $checkoutButton.prop('disabled', true);
      if (!$checkoutButton.hasClass('btn--loading')) {
        $checkoutButton.addClass('btn--loading');
      }

      $.post(window.Shopify.routes.root + 'cart/update.js', { updates })
      .done(function () {

      })
      .fail(function () {
        console.error('Remove GWP Duplicates: Could not process removing all duplicates');
      })
      .always(function () {

      });
      $checkoutButton.prop('disabled', false);
      $checkoutButton.removeClass('btn--loading');
    }
  };

  InlineCart.removeAllGWPItems = () => {
    // console.log('Removing all GWP Items');
    let gwpLineItems = CartJS.cart.items.filter(i => i.properties._is_gwp !== undefined);
    let updates = {};
    gwpLineItems.forEach(item => {
      updates[item.key] = 0;
    });

    let $checkoutButton = $('.inline-cart button[type="submit"]:visible');
    $checkoutButton.prop('disabled', true);
    if (!$checkoutButton.hasClass('btn--loading')) {
      $checkoutButton.addClass('btn--loading');
    }

    $.post(window.Shopify.routes.root + 'cart/update.js', { updates })
    .done(function () {

    })
    .fail(function () {
      console.error('InlineCart.removeAllGWPItems: Could not process removing all GWP items');
    })
    .always(function () {

    });
    $checkoutButton.prop('disabled', false);
    $checkoutButton.removeClass('btn--loading');
  };
  
  InlineCart.discountProgressBar = () => {
    let $cartDiscountWidget = $('.inline-cart .tiered-discount-widget');
    let $pdpProgressBar = $('.pdp-tiered-discount-widget__wrapper .tiered-discount-widget__progress-bar');
    let $cartProgressBar = $('.inline-cart .tiered-discount-widget__progress-bar');

    if ($cartDiscountWidget.length && $pdpProgressBar.length) {
      let progressPercent = $cartProgressBar.width() / $cartDiscountWidget.width() * 100;
      progressPercent = (progressPercent > 100) ? 100 : progressPercent;
      $pdpProgressBar.css({'width': progressPercent + '%'});
    }
  };

  InlineCart.discountGWP = (updateBy = 0) => {
    let cartQTY = 0;
    let items = CartJS.cart.items.filter(i => i.properties._free_sample_index === undefined).filter(k => k.properties._is_gwp === undefined);
    let $progressBar = $('.inline-cart .tiered-discount-widget__progress-bar');

    items.forEach(item => {
      if (item.quantity > 0) {
        cartQTY += item.quantity;
      }
    });
    cartQTY = cartQTY + updateBy;

    let gwpLineItems = CartJS.cart.items.filter(i => i.properties._is_gwp !== undefined);

    if ($progressBar.length === 0) return;

    if ($progressBar.data('type') === 'get-x-get-y-percent-off') {
      let gwpThreshold = $progressBar.data('free-gift-enabled');
      let variantID = $progressBar.data('free-gift-variant-id');

      if (variantID === '' || variantID.length === 0 || typeof variantID === 'undefined') {
        variantID = $progressBar.data('free-gift-first-available-variant');
      }
      if (variantID === '' || variantID.length === 0 || typeof variantID === 'undefined') return console.error('Incorrect Variant ID');

      if (cartQTY >= gwpThreshold && gwpLineItems.length === 0) {
        // console.log('Adding GWP Item');
        CartJS.addItem(variantID, 1, {
          '_is_gwp': true
        });
      }
      else if (gwpLineItems.length > 0 && cartQTY < gwpThreshold) {
        // remove all GWP items via ajax
        window.setTimeout(function () {
          InlineCart.removeAllGWPItems();
        }, 3000);
      }
    }
    else if ($progressBar.data('type') === 'get-x-get-y-product' || $progressBar.data('type') === 'spend-x-get-y-product') {
      let gwpVariants = [];
      let $tiers = $('.inline-cart .tiered-discount-widget__tier-circle');

      $tiers.each(function () {
        let variantID = $(this).data('free-gift-first-available-variant-id');
        let threshold = $(this).data('free-gift-threshold');
        let productTitle = $(this).data('product-title');

        gwpVariants.push({
          variantID: variantID,
          threshold: threshold,
          productTitle: productTitle,
          addedToCart: false,
          removeFromCart: false,
        });
      });

      let thresholdIndex = undefined;

      if ($progressBar.data('type') === 'get-x-get-y-product') {
        thresholdIndex = gwpVariants.findIndex(i => i.threshold === cartQTY);
      }
      else if ($progressBar.data('type') === 'spend-x-get-y-product') {
        let cartPrice = 0;
        const cartItems = CartJS.cart.items.filter(i => i.properties._is_gwp === undefined).filter(k => k.properties._free_sample_index === undefined);

        cartItems.map(i => {
          cartPrice += i.final_line_price / 100;
        });

        gwpVariants.map((variant, i) => {
          if (variant.threshold < cartPrice) {
            thresholdIndex = i;
          }
        });
      }

      if (thresholdIndex !== undefined) {
        const gwpItems = gwpVariants.slice(0, thresholdIndex + 1);
        const disqualifiedGWPs = gwpVariants.slice(thresholdIndex + 1);

        if (disqualifiedGWPs.length > 0) {
          disqualifiedGWPs.forEach(gift => {
            const giftIsAdded = gwpLineItems.find(i => i.variant_id === gift.variantID || i.product_title === gift.productTitle);

            if (giftIsAdded !== undefined) {
              gift.removeFromCart = true;
              gift.key = giftIsAdded.key;
            }
          });

          const giftsToBeRemoved = disqualifiedGWPs.filter(i => i.removeFromCart === true);
          if (giftsToBeRemoved.length > 0) {
            let updates = {};
            giftsToBeRemoved.forEach(item => {
              updates[item.key] = 0;
            });

            $.post(window.Shopify.routes.root + 'cart/update.js', { updates })
            .done(function () {})
            .fail(function () {
              console.error('InlineCart.discountGWP: Could not process removing all GWP items');
            })
            .always(function () {});
          }

          window.setTimeout(function () {
            InlineCart.removeDuplicateGWPs();
          }, 3000);
        }

        if (gwpItems.length > 0) {
          gwpItems.forEach(gift => {
            const giftIsAdded = gwpLineItems.find(i => i.variant_id === gift.variantID || i.product_title === gift.productTitle);

            if (giftIsAdded !== undefined) {
              gift.addedToCart = true;
            }
          });

          const giftsToBeAdded = gwpItems.filter(i => i.addedToCart === false);
          if (giftsToBeAdded.length > 0) {
            giftsToBeAdded.map(gift => {
              window.setTimeout(function () {
                let gwpLineItems = CartJS.cart.items.filter(i => i.properties._is_gwp !== undefined);
                let existingGWP = gwpLineItems.find(i => i.variant_id === gift.variantID);

                if (existingGWP === undefined) {
                  CartJS.addItem(gift.variantID, 1, {
                    '_is_gwp': true
                  });
                }
              }, 1000);
            });
          }
        }
      }
      else if (thresholdIndex === undefined && gwpLineItems.length > 0) {
        window.setTimeout(function () {
          InlineCart.removeAllGWPItems();
        }, 3000);
      }

      window.setTimeout(function () {
        InlineCart.removeDuplicateGWPs();
      }, 5000);
    }
    // console.log(CartJS.cart.items);
  };

  const initDiscountWidgets = () => {
    let threshold = window.cartDiscount.threshold;
    if (window.cartDiscount.enabled_in_cart) {
      // wait for the widget to load up
      let waitForCartWidget = setInterval(function() {
        if($('#cart-discount-widget').length) {
          updateDiscountWidget('cart', threshold);
          clearInterval(waitForCartWidget);
        }
      }, 100);
    }

    if (window.cartDiscount.enabled_in_pdp && window.productJSON) {
      // wait for the widget to load up
      let waitForPdpWidget = setInterval(function() {
        if($('#pdp-discount-widget').length) {
          updateDiscountWidget('pdp', threshold);
          $('#pdp-discount-widget').addClass('loaded');
          clearInterval(waitForPdpWidget);
          return;
        }
      }, 100);

      $(document).on('cart.requestComplete', function() {
        updateDiscountWidget('pdp', threshold);
      });
    }
  }

  const updateDiscountWidget = (context, threshold) => {
    let itemCount = CartJS.cart.item_count;
    let shakerCount = countShakers();
    let sampleCount = countSamples();
    let realFreeGiftsCount = 0;
    let realCount = itemCount - shakerCount - sampleCount;
    if (window.cartDiscount.buy_x_get_free_gift) {
      if (window.cartDiscount.threshold_type == 'quantity') {
        if (realCount > threshold) {
          realFreeGiftsCount = Math.min(countFreeGifts(), 1);
          realCount -= realFreeGiftsCount;
        }
        // Since shaker is excluded from qualifying, existence of it would count as real free gift.
        if (shakerCount != 0) {
          realFreeGiftsCount = 1;
        }
      } else if (window.cartDiscount.threshold_type == 'subtotal') {
        realCount = CartJS.cart.original_total_price / 100;
        if (realCount > threshold) {
          let freeGiftMin = 0;
          CartJS.cart.items.forEach((item) => {
            if (window.cartDiscount.freeGiftProductIds.indexOf(item.product_id) !== -1) {
              if (freeGiftMin === 0 || freeGiftMin > item.original_price) {
                freeGiftMin = item.original_price;
              }
            }
          });
          freeGiftMin = freeGiftMin / 100;
          if (realCount - freeGiftMin >= threshold) {
            realFreeGiftsCount = freeGiftMin;
            realCount -= realFreeGiftsCount;
          }
        }
      }
    }
    let diff = threshold - realCount;
    
    // Set percentage for cart widget bar
    let percentComplete = Math.round((realCount / threshold).toFixed(2) * 100);
    if (diff >= threshold) {
      setWidgetPercentage('empty', 0);
    } else if (diff > 0) {
      setWidgetPercentage('progress', percentComplete);
    } else {
      setWidgetPercentage('complete', 100);
    }

    if (context === 'pdp') {
      // Set message for PDP widget
      if (realCount >= threshold) {
        setPdpMessage('complete', diff);
      } else if (realCount > 0) {
        setPdpMessage('progress', diff);
      } else {
        setPdpMessage('empty', diff);
      }
    } else if (context === 'cart') {
      // Set message for cart widget
      if (realCount >= threshold) {
        setCartMessage('complete', diff);
      } else if (realCount > 0) {
        setCartMessage('progress', diff);
      } else {
        setCartMessage('empty', diff);
      }
    }

    if (window.cartDiscount.buy_x_get_free_gift) {
      if (realCount >= threshold && realFreeGiftsCount === 0) {
        $('.cart-discount-widget__free_gifts_wrapper, .pdp-discount-widget__free_gifts_wrapper').show();
      } else {
        $('.cart-discount-widget__free_gifts_wrapper, .pdp-discount-widget__free_gifts_wrapper').hide();
      }
    }
  }

  const setWidgetPercentage = (state, percent) => {
    let percentString = `${percent}%`;
    $('.discount-percent-bar').text(percentString);
    $('.cart-discount-widget__bar--inner, .pdp-discount-widget__bar--inner').css('width', percentString);

    if(state === 'empty') {
      $('.discount-percent-bar').addClass('empty');
    } else {
      $('.discount-percent-bar').removeClass('empty');
    }

    $('.cart-discount-widget').show(); // for now
  }

  const setPdpMessage = (state, diff) => {
    let threshold = window.cartDiscount.threshold;
    let msgBox = $('.pdp-discount-widget__message');
    let thresholdSpan = $('#pdp-discount-threshold');
    let singularItem = (diff === 1) ? true : false;
    if (state === 'complete') {
      msgBox.html(window.cartDiscount.pdp_messaging.complete);
    } else if (state == 'progress') {
      msgBox.html(window.cartDiscount.pdp_messaging.progress);
      $('#pdp-discount-threshold').text(diff);
      if (singularItem) msgBox.html(msgBox.html().replace('items', 'item'));
    } else {
      // empty cart
      msgBox.html(window.cartDiscount.pdp_messaging.empty);
      if(thresholdSpan) thresholdSpan.text(threshold);
    }
  }

  const setCartMessage = (state, diff) => {
    let threshold = window.cartDiscount.threshold;
    let msgBox = $('.cart-discount-widget__message');
    let thresholdSpan = $('#cart-discount-threshold');
    let singularItem = (diff === 1) ? true : false;
    if (window.cartDiscount.threshold_type == 'subtotal') {
      diff = '$' + diff.toFixed(2);
    }
    if (state === 'complete') {
      msgBox.html(window.cartDiscount.cart_messaging.complete);
    } else if (state == 'progress') {
      msgBox.html(window.cartDiscount.cart_messaging.progress);
      $('#cart-discount-threshold, #pdp-discount-threshold').text(diff);
      if (singularItem) msgBox.html(msgBox.html().replace('items', 'item'));
    } else {
      // empty cart
      msgBox.html(window.cartDiscount.cart_messaging.empty);
      if(thresholdSpan) thresholdSpan.text(threshold);
    }
  }

  const countShakers = () => {
    let shakerCount = 0;
    let cartItems = CartJS.cart.items;
    Object.keys(cartItems).forEach(item => {
      if(cartItems[item].handle.includes('shaker')) {
        shakerCount += Number(cartItems[item].quantity);
      }
    });
    return shakerCount;
  }

  const countSamples = () => {
    let sampleCount = 0;
    CartJS.cart.items.forEach(item => {
      if (item.product_type.includes('Sample')) {
        sampleCount += item.quantity;
      }
    });
    return sampleCount;
  }

  const countFreeGifts = () => {
    let freeGiftCount = 0;
    if (window.cartDiscount.buy_x_get_free_gift) {
      CartJS.cart.items.forEach((item) => {
        if (window.cartDiscount.freeGiftProductIds.indexOf(item.product_id) !== -1) {
          freeGiftCount += item.quantity;
        }
      });
    }
    return freeGiftCount;
  };

  InlineCart.updatePDPFreeSamples = ($lineItem, isIncrement, newValue) => {
    const lineItemId = $lineItem.attr($lineItem.hasClass('cart-item') ? 'data-variant' : 'data-line-item-id');
    const lineItemTitle = $lineItem.attr('data-line-item-title');
    const freeSamplesProduct1Attr = $lineItem.attr('data-pdpfreesample1');
    const freeSamplesProduct1Data = typeof freeSamplesProduct1Attr !== 'undefined' ? freeSamplesProduct1Attr.split('|') : false;
    const freeSamplesProduct2Attr = $lineItem.attr('data-pdpfreesample2');
    const freeSamplesProduct2Data = typeof freeSamplesProduct2Attr !== 'undefined' ? freeSamplesProduct2Attr.split('|') : false;
    let lineItemProperties = {
      '_free_sample_for_variant_id': lineItemId,
      '_free_sample_for_product': lineItemTitle
    };

    if (isIncrement === true) {
      if (freeSamplesProduct1Data) {
        lineItemProperties['_free_sample_for_quantity'] = newValue;
        lineItemProperties['_free_sample_index'] = 1;
        CartJS.addItem(freeSamplesProduct1Data[2], 1, lineItemProperties);
      }
      if (freeSamplesProduct2Data) {
        lineItemProperties['_free_sample_for_quantity'] = newValue;
        lineItemProperties['_free_sample_index'] = 2;
        CartJS.addItem(freeSamplesProduct2Data[2], 1, lineItemProperties);
      }
    } else {
      for (let lineNumber = CartJS.cart.items.length; lineNumber >= 1; lineNumber--) {
        let lineItem = CartJS.cart.items[lineNumber - 1];

        if (Object.keys(lineItem.properties).length > 0) {
          let removeLineItem =
            typeof lineItem.properties['_free_sample_for_variant_id'] !== 'undefined'
            && lineItem.properties['_free_sample_for_variant_id'] == lineItemId
            && typeof lineItem.properties['_free_sample_for_quantity'] !== 'undefined'
            && lineItem.properties['_free_sample_for_quantity'] >= newValue + 1;

          if (newValue === 0) {
            removeLineItem =
              typeof lineItem.properties['_free_sample_for_variant_id'] !== 'undefined'
              && lineItem.properties['_free_sample_for_variant_id'] == lineItemId;
          }

          if (removeLineItem === true) {
            CartJS.removeItem(lineNumber);
          }
        }
      }
    }
  };

  const bindInlineCartUiActions = () => {
    $dom.toggleCart.on('click', function (e) {
      e.preventDefault();
      if ($dom.inlineCart.hasClass('is-active')) {
        InlineCart.toggle('hide');
      } else {
        InlineCart.toggle('show');
      }
    });

    $(document).on('click', '[data-close-cart]', function () {
      InlineCart.toggle('hide');
    });

    $('[data-overlay]').on('click', function () {
      if(InlineCart.PDPFreeSamplesModal.isActive === true) {
        InlineCart.PDPFreeSamplesModal.toggle('hide');
      } else {
        InlineCart.toggle('hide');
      }
    });

    $dom.pdpFreeSamplesModal.on('click', function (event) {
      const $target = $(event.target);
      if($target.is($dom.pdpFreeSamplesModalSelector)) {
        InlineCart.PDPFreeSamplesModal.toggle('hide');
      }
    });

    $(document).on('click', '.qty-change', function () {
      const isIncrement = $(this).hasClass('qtyplus');
      let $lineItem = $(this).closest('.line-item');
      let lineItemId = $lineItem.attr('data-line-item-id');
      let lineNumber = $lineItem.attr('data-line-number');
      let updateBy = parseInt($(this).attr('data-update-by'));
      let currentVal = 0;
      currentVal = parseInt($lineItem.find('.qty').text(), 10);

      if (!isNaN(currentVal) && currentVal > 0) {
        let newVal = currentVal + updateBy;
        CartJS.updateItem(lineNumber, newVal);
        InlineCart.updatePDPFreeSamples($lineItem, isIncrement, newVal);
      } else {
        CartJS.removeItemById(lineItemId);
        InlineCart.updatePDPFreeSamples($lineItem, isIncrement, 0);
      }
      window.setTimeout(function () {
        InlineCart.discountGWP(0);
      }, 2000);
    });

    $(document).on(
      'click',
      '.cart-item[data-pdpfreesample1] .cart-item-decrease, .cart-item[data-pdpfreesample1] .cart-item-increase,' +
      '.cart-item[data-pdpfreesample2] .cart-item-decrease, .cart-item[data-pdpfreesample2] .cart-item-increase',
      function () {
        const isIncrement = $(this).hasClass('cart-item-increase');
        let $lineItem = $(this).closest('.cart-item');
        let lineItemId = $lineItem.attr('data-variant');
        let lineNumber = $lineItem.attr('data-line');
        let updateBy = isIncrement ? 1 : -1;
        let currentVal = 0;
        currentVal = parseInt($lineItem.find('.cart-item-quantity-display').val(), 10);

        if (!isNaN(currentVal) && currentVal > 0) {
          let newVal = currentVal + updateBy;
          CartJS.updateItem(lineNumber, newVal);
          InlineCart.updatePDPFreeSamples($lineItem, isIncrement, newVal);
        } else {
          CartJS.removeItemById(lineItemId);
          InlineCart.updatePDPFreeSamples($lineItem, isIncrement, 0);
        }
      });

    $(document).on('click', '[data-remove-item]', function () {
      let variantId = $(this).attr('data-variant-id');
      let $lineItem = $(this).closest('.line-item');
      let lineItemId = $lineItem.attr('data-line-item-id');

      if(typeof $(this).data('bundle-variants') !== 'undefined') {
        let bundleVariants = $(this).data('bundle-variants').split('|');
        bundleVariants.filter(id => id.length > 0).forEach(id => InlineCart.removeItem(Number(id)));
      }

      if (variantId > 0) {
        InlineCart.removeItem(variantId);
      } else if (lineItemId > 0) {
        CartJS.removeItemById(lineItemId);
      }

      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('item-removed', {
          detail: { id: variantId || lineItemId } 
        }));
      }, 1000);
    });

    $(document).on('cart.requestComplete', (event, cart) => {
      // Remove all freebies in the cart if there are no regular products

      /**
       * this code reload the page if is the /cart page,
       * if is minicart it continues.
       */
      if ($('body').hasClass('template-cart')) {
        window.location.reload();
        return false;
      }

      if ((CartJS.cart.items.length > 0 && CartJS.cart.total_price === 0) || (CartJS.cart.items.filter(i => i.properties._is_gwp !== undefined).length === CartJS.cart.items.length)) {
        let updates = {};

        CartJS.cart.items.forEach(item => {
          updates[item.key] = 0;
        });

        let $checkoutButton = $('.inline-cart button[type="submit"]:visible');
        $checkoutButton.prop('disabled', true);

        if (!$checkoutButton.hasClass('btn--loading')) {
          $checkoutButton.addClass('btn--loading');
        }

        $.post(window.Shopify.routes.root + 'cart/update.js', { updates })
        .done(function () {

        })
        .fail(function () {
          console.error('document.ready: Could not process removing all items');
        })
        .always(function () {

        });
        $checkoutButton.prop('disabled', false);
        $checkoutButton.removeClass('btn--loading');
      }

      InlineCart.removeDuplicateGWPs();
      InlineCart.update();
    });

    document.addEventListener('rebuy:cart.change', function (event) {
      InlineCart.update();
    });

    document.addEventListener('rebuy:cart.add', function (event) {
      InlineCart.toggle('show');
    });

    // click even for the upsell item for inline cart
    $(document).on('click','[inline-cart-add-item]', (event) => {
      // grabs variant id
        const variantId = $('.js-upsell-cart-variant-select').val();

      // changes the color of the svg
      $('.circle').css('fill','none');
      $('.plus-sign').css('fill','#ED1C24');
      // does the animation for descontructing svg circle
      $('.circle').addClass('animate');
      // checks for when animation is complete
      $('.animate').one('webkitAnimationEnd oanimationend msAnimationEnd animationend', () => {
        // changes opacity of upsell item then addes it to the cart on success
        $('.upsell-product__wrapper').addClass('added-to-cart');
        CartJS.addItem(variantId, 1, { Cart: 'Upsell' }, {
          success: (data, textStatus, jqXHR) => {
            window.setTimeout(function () {
              InlineCart.discountGWP(0);
            }, 3000);
          },

          error: (jqXHR, textStatus, errorThrown) => {
            // if it fails, it changes the the svg back to default state
            $('.circle').removeClass('animate');
            window.alert('Sorry, we\'re unable to do that.\n Please make a selection.');
          }
        });
      });
    });

    if (window.cartDiscount.buy_x_get_free_gift) {
      $(document).on('click', '[data-inline-cart-fg-control]', (event) => {
        const ns = $(event.currentTarget).closest('[class*="-discount-widget__free_gifts_select"]').attr('class').indexOf('pdp') > -1 ? 'pdp' : 'cart';
        const direction = $(event.currentTarget).attr('data-inline-cart-fg-control');
        const $freeGifts = $('.' + ns + '-discount-widget__free_gifts');
        const $freeGift = $freeGifts.find('.' + ns + '-discount-widget__free_gift');
        const itemWidth = $freeGift.width();
        const freeGiftsCount = $freeGift.length;
        const currentLeft = $freeGifts.scrollLeft();
        let newLeft = direction == 'left' ? currentLeft - (itemWidth * 3) : currentLeft + (itemWidth * 3);
        if (currentLeft === 0 && newLeft < 0) {
          newLeft = itemWidth * 3;
        }
        else if (newLeft > (freeGiftsCount * itemWidth)) {
          newLeft = 0;
        }
        $freeGifts.animate({ scrollLeft: newLeft }, 750);
      });

      $(document).on('click', '[data-inline-cart-fg-tile]', (event) => {
        $('.cart-discount-widget__free_gifts_wrapper, .pdp-discount-widget__free_gifts_wrapper').addClass('is-details');
        const $freeGift = $(event.currentTarget).parent();
        $('.cart-discount-widget__free_gift, .pdp-discount-widget__free_gift').hide();
        $freeGift.show();
        $freeGift.find('.cart-discount-widget__free_gift_details').show();
        $('.pdp-discount-widget__free_gift_details').show();
      });

      $(document).on('click', '[data-inline-cart-fg-back]', (event) => {
        $('.cart-discount-widget__free_gifts_wrapper, .pdp-discount-widget__free_gifts_wrapper').removeClass('is-details');
        $('.cart-discount-widget__free_gift, .pdp-discount-widget__free_gift').show();
        $(event.currentTarget).closest('.cart-discount-widget__free_gift_details').hide();
        $('.pdp-discount-widget__free_gift_details').hide();
      });

      $(document).on('click change', '[data-inline-cart-fg-select], [data-pdp-fg-select]', (event) => {
        const $thisSelect = $(event.currentTarget),
              ns = $thisSelect.closest('[class*="-discount-widget__free_gifts_wrapper"]').attr('class').indexOf('pdp') > -1 ? 'pdp' : 'cart',
              variantId = $thisSelect.val(),
              variantImage = $thisSelect.find(`option[data-image][value="${variantId}"]`).length > 0 ? $thisSelect.find(`option[data-image][value="${variantId}"]`).attr('data-image') : '';
        if(variantImage.length > 0) {
          $thisSelect.closest(`.${ns}-discount-widget__free_gift_details`).find('a img').attr('src', `https:${variantImage}`);
        }
      });

      $(document).on('click', '[data-inline-cart-fg-atc]', (event) => {
        const variantId = $(event.currentTarget).parent().find('select').val();
        CartJS.addItem(variantId, 1);
        if ($(event.currentTarget).attr('class').indexOf('pdp') > -1) {
          Overlay.show();
          $dom.inlineCart.addClass('is-active');
          window.setTimeout(function () {
            InlineCart.discountGWP(0);
          }, 3000);
        }
      });
    }

    $(document).ready(function () {
      initDiscountWidgets();

      // Remove all freebies in the cart if there are no regular products
      if ((CartJS.cart.items.length > 0 && CartJS.cart.total_price === 0) || (CartJS.cart.items.filter(i => i.properties._is_gwp !== undefined).length === CartJS.cart.items.length)) {
        let updates = {};

        CartJS.cart.items.forEach(item => {
          updates[item.key] = 0;
        });

        let $checkoutButton = $('.inline-cart button[type="submit"]:visible');
        $checkoutButton.prop('disabled', true);

        if (!$checkoutButton.hasClass('btn--loading')) {
          $checkoutButton.addClass('btn--loading');
        }

        $.post(window.Shopify.routes.root + 'cart/update.js', { updates })
        .done(function () {

        })
        .fail(function () {
          console.error('document.ready: Could not process removing all items');
        })
        .always(function () {

        });
        $checkoutButton.prop('disabled', false);
        $checkoutButton.removeClass('btn--loading');
      }

      window.setTimeout(function () {
        InlineCart.discountGWP(0);
      }, 3000);
      InlineCart.removeDuplicateGWPs();
    });

    $(document).on('click','.inline-cart .selectric-wrapper .selectric', function () {
      $(this).closest('.selectric-wrapper').toggleClass('selectric-open');
    });

    $(document).on('click', '.inline-cart .selectric-wrapper .selectric-items li', function () {
      $(this).closest('.selectric-wrapper').removeClass('selectric-open');
      const currentVariantID = $(this).closest('.line-item').data('line-item-id');
      let variantID = $(this).data('variant-id');

      // Remove current GWP line item in the Cart
      let gwpLineItem = CartJS.cart.items.filter(i => i.properties._is_gwp !== undefined).find(k => k.variant_id === currentVariantID);
      let updates = {};
      updates[gwpLineItem.key] = 0;

      let $checkoutButton = $('.inline-cart button[type="submit"]:visible');
      $checkoutButton.prop('disabled', true);
      if (!$checkoutButton.hasClass('btn--loading')) {
        $checkoutButton.addClass('btn--loading');
      }

      $.post(window.Shopify.routes.root + 'cart/update.js', { updates })
      .done(function () {
        // console.log('Successful Removal of GWP items');
      })
      .fail(function () {
        // console.error('Selectric: Could not process removing all GWP items');
      })
      .always(function () {

      });
      $checkoutButton.prop('disabled', false);
      $checkoutButton.removeClass('btn--loading');

      // Add one GWP item to cart
      window.setTimeout(function () {
        CartJS.addItem(variantID, 1, {
          '_is_gwp': true
        });
      }, 1000);
    });
  }

  InlineCart.PDPFreeSamplesModal = {
    isActive: false
  };

  InlineCart.PDPFreeSamplesModal.toggle = action => {
    if (action === 'show') {
      Overlay.show();
      $dom.pdpFreeSamplesModal.addClass('is-active');
      $dom.body.addClass('pdp-free-samples-modal-is-active');
      InlineCart.PDPFreeSamplesModal.isActive = true;
      Overlay.dontHideOnClick = true;
    } else if (action === 'hide') {
      if (!$dom.inlineCart.hasClass('is-active')) {
        Overlay.hide();
      }
      $dom.pdpFreeSamplesModal.removeClass('is-active');
      $dom.body.removeClass('pdp-free-samples-modal-is-active');
      InlineCart.PDPFreeSamplesModal.isActive = false;
      setTimeout(() => { Overlay.dontHideOnClick = false; }, 200);
    }
  };

  InlineCart.PDPFreeSamplesModal.update = (callback) => {
    $.get('/cart?view=pdpfreesamples')
    .then(response => {
      $dom.pdpFreeSamplesModalItemsList.html(response);

      $($dom.pdpFreeSamplesModalItemsList).find('.js-style-select').selectric();

      if (typeof callback === 'function') {
        callback();
      }
    })
    .done(() => {});
  };

  const bindPDPFreeSamplesUiActions = () => {

    $dom.inlineCart.on('click', $dom.pdpFreeSamplesModalToggleSelector, (e) => {
      e.preventDefault();
      if (true === InlineCart.PDPFreeSamplesModal.isActive) {
        InlineCart.PDPFreeSamplesModal.toggle('hide');
      } else {
        InlineCart.PDPFreeSamplesModal.toggle('show');
      }
    });

    $dom.pdpFreeSamplesModal.on('change', $dom.pdpFreeSamplesModalVariantSelectboxSelector, (event) => {
      const $self = $(event.currentTarget);
      const newVariantId = $self.val() * 1;
      const $lineItemElement = $self.closest($dom.pdpFreeSamplesModalVariantSelector);
      $lineItemElement.attr($dom.pdpFreeSamplesModalNewVariantAttribute, newVariantId);
      const lineNumber = $lineItemElement.attr('data-line-number') * 1;
      let newLineItemProperties = CartJS.cart.items[lineNumber - 1].properties;
      newLineItemProperties['_chosen_by_customer'] = 'Yes';
      CartJS.removeItem(lineNumber);
      CartJS.addItem(newVariantId, 1, newLineItemProperties, {
        success: (data, textStatus, jqXHR) => {},
        error: (jqXHR, textStatus, errorThrown) => {
          window.alert('Sorry, we\'re unable to do that.\n' + JSON.parse(jqXHR.responseText).description);
        }
      });
    });

    const pdpFreeSamplesModalCloseHandler = (event) => {
      event.preventDefault();
      InlineCart.PDPFreeSamplesModal.toggle('hide');
    };
    $dom.pdpFreeSamplesModalCloseBtn.on('click', pdpFreeSamplesModalCloseHandler);
    $dom.pdpFreeSamplesModalSaveButton.on('click', pdpFreeSamplesModalCloseHandler);

  };

  InlineCart.init = () => {
    cacheDom();
    bindInlineCartUiActions();
    bindPDPFreeSamplesUiActions();
    InlineCart.update();
    InlineCart.discountGWP(0);
  };

}(window.InlineCart = window.InlineCart || {}, jQuery));
